import React from 'react'
import { FaChevronRight, FaChevronDown } from 'react-icons/fa'

/**
 * One row in the "Mine skift" list. Expands to show trip counts and
 * shift number, matching the design.
 */
const ShiftListItem = ({ shift, expanded, onToggle }) => {
   return (
      <div className="border-b border-gray-100 last:border-b-0">
         <button
            onClick={onToggle}
            className="w-full flex items-center gap-3 px-4 py-3 text-left focus:outline-none">
            {expanded ? (
               <FaChevronDown className="text-gray-400 flex-shrink-0" size={12} />
            ) : (
               <FaChevronRight className="text-gray-400 flex-shrink-0" size={12} />
            )}

            <div className="flex-1 grid grid-cols-2 gap-2">
               <div>
                  <div className="text-xs md:text-sm text-gray-400">{shift.startDate}</div>
                  <div className="text-sm md:text-base font-semibold text-gray-800">{shift.startTime}</div>
                  <div className="text-xs md:text-sm text-gray-500">Start</div>
               </div>
               <div>
                  <div className="text-xs md:text-sm text-gray-400">{shift.endDate}</div>
                  <div className="text-sm md:text-base font-semibold text-gray-800">{shift.endTime}</div>
                  <div className="text-xs md:text-sm text-gray-500">Slutt</div>
               </div>
            </div>

            <div className="text-right flex-shrink-0">
               <div className="text-sm md:text-base font-semibold text-gray-800">{shift.revenue} kr</div>
               <div className="text-xs md:text-sm text-gray-500">Omsetning</div>
            </div>
         </button>

         {expanded && (
            <div className="grid grid-cols-3 gap-2 bg-gray-100 px-4 py-3 text-sm md:text-base">
               <div>
                  <div className="font-semibold text-gray-800">{shift.tripCount}</div>
                  <div className="text-xs md:text-sm text-gray-500">Antall turer</div>
               </div>
               <div>
                  <div className="font-semibold text-gray-800">{shift.rejectedCount}</div>
                  <div className="text-xs md:text-sm text-gray-500">Avviste turer</div>
               </div>
               <div>
                  <div className="font-semibold text-gray-800">{shift.shiftNumber}</div>
                  <div className="text-xs md:text-sm text-gray-500">Skiftnr.</div>
               </div>
            </div>
         )}
      </div>
   )
}

export default ShiftListItem
